import React, { useState } from "react";

import OverviewTab from "./tabs/OverviewTab.jsx";
import SettingsTab from "./tabs/SettingsTab.jsx";
import MarketplaceTab from "./tabs/MarketplaceTab.jsx";
import UsersTab from "./tabs/UsersTab.jsx";
import AuditTab from "./tabs/AuditTab.jsx";

export default function OwnerApp({ user }) {
  const [tab, setTab] = useState("overview");
  React.useEffect(() => {
    console.log("[owner] OwnerApp mounted, user.uid =", user?.uid || null);
  }, [user?.uid]);

  if (!user?.uid) {
    return (
      <div className="owner">
        <div className="container content-container">
          <div className="config-card" style={{ padding: 16 }}>
            Vous devez être connecté pour accéder au tableau de bord propriétaire.
          </div>
        </div>
      </div>
    );
  }

  const TabBtn = ({ id, icon, label }) => (
    <button
      className={`tab ${tab === id ? "active" : ""}`}
      onClick={() => setTab(id)}
      role="tab"
      aria-selected={tab === id}
      aria-controls={`panel-${id}`}
      id={`tab-${id}`}
    >
      <i className={`fas ${icon}`} />
      <span style={{ marginLeft: 8 }}>{label}</span>
    </button>
  );

  return (
    // ---------- WRAPPER SCOPÉ : active tout le style de owner.css ----------
    <div className="owner">
      {/* En-tête collant façon maquette */}
      <div className="dashboard-header">
        <div className="container header-content">
          <h1 className="page-title">
            <i className="fas fa-crown" />
            Tableau de Bord Propriétaire
          </h1>

          <div className="global-controls">
            <input className="search-box" placeholder="Recherche globale..." />
            <div className="user-menu" style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div className="user-avatar"><i className="fas fa-user-shield" /></div>
              <span>Propriétaire</span>
            </div>
          </div>
        </div>
      </div>

      {/* Barre d’onglets stylée (owner.css) */}
      <nav className="tabs-navigation" role="tablist" aria-label="Onglets propriétaire">
        <div className="container tabs-container">
          <TabBtn id="overview" icon="fa-chart-line" label="Vue d'ensemble" />
          <TabBtn id="users" icon="fa-users" label="Utilisateurs" />
          <TabBtn id="settings" icon="fa-cog" label="Réglages du site" />
          <TabBtn id="marketplace" icon="fa-store" label="Modération Marketplace" />
          <TabBtn id="audit" icon="fa-clipboard-list" label="Journal d'audit" />
        </div>
      </nav>

      {/* Contenu des onglets */}
      <div className="container content-container">
        <section
          id="panel-overview"
          className={`tab-content ${tab === "overview" ? "active" : ""}`}
          role="tabpanel"
          aria-labelledby="tab-overview"
        >
          <OverviewTab />
        </section>

        <section
          id="panel-users"
          className={`tab-content ${tab === "users" ? "active" : ""}`}
          role="tabpanel"
          aria-labelledby="tab-users"
        >
          <UsersTab user={user} />
        </section>

        <section
          id="panel-settings"
          className={`tab-content ${tab === "settings" ? "active" : ""}`}
          role="tabpanel"
          aria-labelledby="tab-settings"
        >
          <SettingsTab user={user} />
        </section>

        <section
          id="panel-marketplace"
          className={`tab-content ${tab === "marketplace" ? "active" : ""}`}
          role="tabpanel"
          aria-labelledby="tab-marketplace"
        >
          <MarketplaceTab user={user} />
        </section>

        <section
          id="panel-audit"
          className={`tab-content ${tab === "audit" ? "active" : ""}`}
          role="tabpanel"
          aria-labelledby="tab-audit"
        >
          <AuditTab />
        </section>
      </div>
    </div>
  );
}
